import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import checkCircularImage from "../../assets/check_circular.png";
import Layout from "../../components/layout/Layout";

const AssignmentSetSucessPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoaded) {
      return;
    }
    setIsLoaded(true);
  }, [isLoaded]);

  return !isLoaded ? null : (
    <Layout showSideNav={false}>
      <div style={{ width: "50%", margin: "auto" }}>
        <img
          src={checkCircularImage}
          alt="Assignment Set Success"
          style={{ width: "150px", height: "150px" }}
        />
        <h1 style={{ fontSize: "2rem" }}>Your new assignment is set</h1>
        <p style={{ fontSize: "1.2rem" }}>
          We emailed the caregivers to let them know about their new clients,
          and the caregivers can now provide remote care to the clients you
          assigned them to.
        </p>
        <button
          className="btn-primary"
          style={{
            color: "#000",
            backgroundColor: "#66A77B",
            padding: "10px 20px",
            fontSize: "1.2rem",
          }}
          onClick={(ev) => {
            ev.preventDefault();
            navigate("/assignment_center");
          }}
        >
          Got it
        </button>
      </div>
    </Layout>
  );
};

export default AssignmentSetSucessPage;
